module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"btnTranslate":"Language","langEn":"English","langEs":"Spanish"},"es":{"btnTranslate":"Idioma","langEn":"Inglés","langEs":"Español"}}')
  delete Component.options._Ctor
}
